/**
 * RoadSegmentsPanel - Panel de inventario de segmentos viales
 *
 * @module roadways/components/panels
 * @description Wrapper que utiliza BaseInventoryPanel con configuración de segmentos viales
 */

import { BaseInventoryPanel } from '../../../../layouts/panels/LeftPanel';
import { roadSegmentsInventoryConfig } from '../../config/road-segments-inventory.config';

/**
 * Panel de inventario de segmentos viales
 *
 * @remarks
 * Usa BaseInventoryPanel genérico con configuración específica.
 * Incluye: narrow/wide modes, paginación, sorting, multi-select, eye/zoom buttons, color picker.
 */
export function RoadSegmentsPanel(): JSX.Element {
  return <BaseInventoryPanel config={roadSegmentsInventoryConfig} />;
}
